var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
import PropTypes from "prop-types";

var NavLink = function NavLink(_ref) {
  var Icon = _ref.icon,
      name = _ref.name,
      classNames = _ref.classNames,
      onClick = _ref.onClick,
      active = _ref.active,
      _ref$iconProps = _ref.iconProps,
      iconProps = _ref$iconProps === undefined ? {} : _ref$iconProps;

  return React.createElement(
    "div",
    {
      className: "side-navigation-nav-link d-flex flex-row align-items-center  " + classNames + " " + (active && "active"),
      onClick: onClick
    },
    React.createElement(
      "div",
      { className: "d-inline-block nav-icon-container text-center" },
      React.createElement(Icon, _extends({ className: "nav-icon", size: "1x" }, iconProps))
    ),
    React.createElement(
      "span",
      { className: "nav-text" },
      name
    )
  );
};

NavLink.defaultProps = {
  classNames: "",
  icon: "bicycle",
  name: "Button",
  navlinkTextClassNames: "",
  iconProps: {},
  onClick: function onClick() {}
};
NavLink.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Name
   */
  name: PropTypes.string,

  /**
   * Active Navigation
   */
  active: PropTypes.bool,

  /**
   * Navlink text style class
   */
  navlinkTextClassNames: PropTypes.string,

  /**
   * onClick button action
   */
  onClick: PropTypes.func,

  /**
   * optional icon properties
   */
  iconProps: PropTypes.object
} : {};
export default NavLink;